<template>
    <b-container fluid>
        <page-title>
            <h2>
                <router-link :to="{ name: 'CustomerList' }" class="nav-link">Klienci</router-link>
            </h2>
            <div class="page-title__buttons">
                <router-link :to="{ name: 'CustomerCreate' }" class="btn btn-default"><span>Dodaj klienta</span>
                    <svg-icon name="plus"/>
                </router-link>
            </div>
        </page-title>

        <div class="col page-element">
            <div v-if="created" class="alert alert-success" role="status">Klient {{ created.fullName }} został dodany.</div>
            <alert-loading v-if="loading"></alert-loading>
            <div v-if="deletedItem" class="alert alert-success">{{ deletedItem['@id'] }} deleted.</div>
            <div v-if="error" class="alert alert-danger">{{ error }}</div>
            <div v-if="!loading">
                <div class="table-responsive">
                    <table class="table table-striped table-bordered table-hover table-clickable table-search">
                        <thead>
                        <tr class="table-search__form">
                            <td>
                                <b-form-input type="text" class="form-control input-search" v-model="filter.name"/>
                                <svg-icon name="search"/>
                            </td>
                            <td>
                                <b-form-input type="text" class="form-control input-search" v-model="filter.nip"/>
                                <svg-icon name="search"/>
                            </td>
                            <td>
                                <b-form-input type="text" class="form-control input-search" v-model="filter.regon"/>
                                <svg-icon name="search"/>
                            </td>
                            <td></td>
                            <td class="no-wrap">
                                <my-button variant="info" :action="getItems"/> <my-button icon="back" variant="primary" :action="resetFilter"/>
                            </td>
                        </tr>
                        <tr>
                            <th v-on:click="setOrder('name')" class="sorting" :class="getOrder('name')">Nazwa firmy</th>
                            <th v-on:click="setOrder('nip')" class="sorting" :class="getOrder('nip')">NIP</th>
                            <th v-on:click="setOrder('regon')" class="sorting" :class="getOrder('regon')">REGON</th>
                            <th v-on:click="setOrder('commission')" class="sorting" :class="getOrder('commission')">
                                Prowizja
                            </th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in items">
                            <td>
                                <router-link v-if="item" :to="{name: 'CustomerShow', params: { id: item['id'] }}">
                                    {{ item['name'] }}
                                </router-link>
                            </td>
                            <td>
                                <router-link v-if="item" :to="{name: 'CustomerShow', params: { id: item['id'] }}">
                                    {{ item['nip'] }}
                                </router-link>
                            </td>
                            <td>
                                <router-link v-if="item" :to="{name: 'CustomerShow', params: { id: item['id'] }}">
                                    {{ item['regon'] }}
                                </router-link>
                            </td>
                            <td>
                                <router-link v-if="item" :to="{name: 'CustomerShow', params: { id: item['id'] }}">
                                    {{ item['commission'] | percentage }}
                                </router-link>
                            </td>
                            <td>
                                <router-link :to="{name: 'CustomerUpdate', params: { id: item.id }}"
                                            v-b-tooltip.hover.bottom title="Edytuj" class="btn btn-icon">
                                    <svg-icon name="edit"/>
                                </router-link>

                                <router-link :to="{name: 'AgreementCreate', query: { customer: item.id }}" v-b-tooltip.hover.bottom title="Dodaj umowę" class="btn btn-icon">
                                    <svg-icon name="agreement_small"/>
                                </router-link>

                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <pagination :changePage="changePage" :currentPage="currentPage" :pagination="pagination"></pagination>
            </div>
        </div>
    </b-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import sort from '../../utils/order'

  export default {
    computed: mapGetters({
      deletedItem: 'customer/del/deleted',
      error: 'customer/list/error',
      items: 'customer/list/items',
      loading: 'customer/list/loading',
      currentPage: 'customer/list/currentPage',
      pagination: 'customer/list/pagination',
      order: 'customer/list/order',
      filter: 'customer/list/filter',
      created: 'customer/create/created',
    }),
    methods: {
      resetFilter(){
        for (var key in this.filter ){
          this.filter[key] = undefined;
        }
        this.getItems();
      },
      getOrder: function (column) {
        return sort(this.order, column)
      },
      ...mapActions({
        getItems: 'customer/list/getItems',
        setOrder: 'customer/list/order',
        changePage: 'customer/list/changePage'
      })
    },
    created () {
      this.$store.dispatch('customer/list/getItems')
    }
  }
</script>


// WEBPACK FOOTER //
// List.vue?4d656375